export default (value: number|string|null, showNullAsEmpty: boolean = false): string => {

    if (value === null && showNullAsEmpty){
        return ''
    }

    const formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
    })
    const money = typeof value === 'string' ? parseFloat(value) : value

    return formatter.format(<number>money)
}
